import type { ReactNode } from 'react';
import { AuthProvider } from '@/providers/AuthProvider';
import { LangProvider } from '@/providers/LangProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { ToastProvider } from '@/providers/ToastProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <LangProvider>
        <ToastProvider>
          <AuthProvider>{children}</AuthProvider>
        </ToastProvider>
      </LangProvider>
    </ThemeProvider>
  );
}
